// extracted by mini-css-extract-plugin
export default {"second_layer":"SecondLayer_second_layer__qPepP"};